import { render, staticRenderFns } from "./selectCustomer.vue?vue&type=template&id=65697a04&scoped=true"
import script from "./selectCustomer.vue?vue&type=script&lang=js"
export * from "./selectCustomer.vue?vue&type=script&lang=js"
import style0 from "./selectCustomer.vue?vue&type=style&index=0&id=65697a04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65697a04",
  null
  
)

export default component.exports